// eslint-disable-next-line no-underscore-dangle,import/prefer-default-export
export const IS_DEV: boolean = window.__isDev;
